import _ from "lodash"

export function GetEpisodeDate(episode) {
  let date

  if (!_.isNull(episode?.episode_intake_date)) {
    date = episode?.episode_intake_date
  } else if (!_.isNull(episode?.manage_services_date)) {
    date = episode?.manage_services_date
  } else if (!_.isNull(episode?.episode_discharge_date)) {
    date = episode?.episode_discharge_date
  }

  return date
}

export function ClassifyEpisode(episode) {
  let episode_name = ""
  let detailEpisode = ""

  switch (episode?.episode_code_id) {
    case "100":
      episode_name = "Service Episode Start"
      detailEpisode = "Intake Session"
      break
    case "101":
      episode_name = "Program ID Change"
      detailEpisode = episode?.program_ids
      break
    case "102":
      episode_name = "Staff Assignment Change"
      detailEpisode = episode?.staff_ids
      break
    case "103":
      episode_name = "Location ID Change"
      detailEpisode = episode?.location_ids
      break
    case "104":
      episode_name = "External ID Change"
      detailEpisode = episode?.external_ids
      break
    case "105":
      episode_name = "Share Participant Record"
      break
    case "106":
      episode_name = "Transfer Participant Record"
      break
    case "200":
      episode_name = "Service Episode End"
      detailEpisode = "Discharge Session"
      break
    default:
      break
  }

  return { episode_name, detailEpisode }
}
